import { chooseObjectForReadonly } from "../../utils/codeSplit";
import { uiStateSelectors } from "../uiState";

const getCompletedTips = state => state.tutorial.completedTips;
const getActiveTutorial = state => state.tutorial.activeTutorial;
const getVisibleTutorial = state => state.tutorial.visibleTutorial;
const getTutorialSilenced = state => state.tutorial.tutorialSilenced;
const getTutorialTooltipShown = state => chooseObjectForReadonly(false, state.tutorial.tutorialTooltipShown);
const getTutorialShouldShowTooltip = state =>
  chooseObjectForReadonly(
    false,
    !state.tutorial.tutorialTooltipShown &&
      !state.tutorial.activeTutorial &&
      !state.tutorial.tutorialSilenced &&
      !uiStateSelectors.isModalOpen(state)
  );

export default {
  getCompletedTips,
  getActiveTutorial,
  getVisibleTutorial,
  getTutorialSilenced,
  getTutorialTooltipShown,
  getTutorialShouldShowTooltip
};
